import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defaultPagingChoices, mvtTypes, stockTypes } from "@/js/lists.ts";
import { request } from "@/js/http/http_request";
import pagingComponent from "@/components/paging/PagingComponent.vue";
import indexComponent from "@/components/paging/IndexComponent.vue";
import MvtStockDetailsPopin from "./MvtStockDetailsPopin.vue";
import { filterVAutocomplete, getErrorData } from "@/js/forms.js";
import { getOrderConfirmationReference } from "@/js/order/order.js";
export default {
  name: "mvtStockList",
  data: function data() {
    return {
      stockTypesFilter: Object.entries(stockTypes).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        return [].concat(_toConsumableArray(acc), [{
          value: key,
          label: value
        }]);
      }, []),
      warehouses: [],
      wines: [],
      baseModel: {
        mvt_stocks: [],
        numberOfMvtStocks: 0,
        numberOfPages: 0
      },
      datatable_loading: true,
      datatable_selected: [],
      datatable_headers: [{
        text: "Date",
        align: "center",
        value: "date"
      }, {
        text: "Product",
        value: "wine",
        align: "center"
      }, {
        text: "Sku",
        value: "sku",
        align: "center"
      }, {
        text: "Reference",
        value: "reference",
        cellClass: "text-nowrap",
        align: "center"
      }, {
        text: "Movement type",
        value: "outgoing_mvt",
        align: "center"
      }, {
        text: "Quantity",
        value: "qty",
        cellClass: "text-nowrap",
        align: "center"
      }, {
        text: "Available after",
        value: "stock_qty_after",
        cellClass: "text-nowrap",
        align: "center"
      }, {
        text: "Warehouse",
        value: "warehouse",
        align: "center",
        cellClass: "text-nowrap"
      }, {
        text: "Destination",
        value: "destination",
        align: "center"
      }],
      datatable_items: [],
      searchCriterias: {
        label: null,
        stock: null,
        wineId: null,
        mvt_type: null,
        warehouseIds: null,
        stockType: null,
        paging: {
          limits: 24,
          currentPage: 0,
          askedPage: 0
        }
      },
      pagingLimitsChoices: defaultPagingChoices,
      mvtTypes: mvtTypes
    };
  },
  computed: {
    hasResult: function hasResult() {
      return !this.datatable_loading && this.baseModel.numberOfMvtStocks > 0;
    }
  },
  components: {
    paging: pagingComponent,
    index: indexComponent,
    MvtStockDetailsPopin: MvtStockDetailsPopin
  },
  created: function created() {
    if (!this.$whitelabel.isAllowedToAccessPurchaseOrder) {
      this.mvtTypes = this.mvtTypes.filter(function (x) {
        return x.value != "future_in_from_po" && x.value != "fill_order";
      });
    } else {
      // The future in from PO must no longer be displayed
      this.mvtTypes = this.mvtTypes.filter(function (x) {
        return x.value != "future_in_from_po";
      });
    }
    this.searchCriterias.mvt_type = this.mvtTypes.reduce(function (acc, mvtType) {
      return [].concat(_toConsumableArray(acc), [mvtType.value]);
    }, []);
    this.search();
    document.body.style.cursor = "wait";
    this.fetchWines();
    this.fetchWarehouses();
  },
  methods: {
    filterVAutocomplete: filterVAutocomplete,
    fetchWines: function fetchWines() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return request("/v1/stock?wines=true", "get", null, true, "api").catch(function (e) {
                var errorData = getErrorData(e, {});
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 2:
              response = _context.sent;
              _this2.wines = response.data.wines.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  display_name: x.display_name + (x.accountancy_code ? " - " + x.accountancy_code : "")
                });
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    fetchWarehouses: function fetchWarehouses() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this3;
              _context2.next = 3;
              return request("/v1/warehouses", "post", {
                paging: null
              }, true, "api").catch(function (e) {
                var errorData = getErrorData(e, {});
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 3:
              response = _context2.sent;
              _this3.warehouses = _toConsumableArray(response.data.warehouses);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.baseModel.numberOfPages) {
        this.searchCriterias.paging.askedPage = askedPage;
        this.search();
      }
    },
    resetPaging: function resetPaging() {
      this.searchCriterias.paging.askedPage = 0;
    },
    getDestination: function getDestination(mvt) {
      if (mvt.mvt_type == "added_basket" || mvt.mvt_type == "removed_basket" || mvt.mvt_type == "fill_order") return "";
      var destination = "";
      if (mvt.destination != "") {
        if (mvt.destination.state != null && mvt.destination.state.state_label != "") {
          destination += mvt.destination.state.state_label + ", ";
        }
        if (mvt.destination.country != "" && mvt.destination.country.printable_name != "") {
          destination += mvt.destination.country.printable_name;
        }
      }
      return destination;
    },
    search: function search() {
      var isResetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.$EventBus.$emit("loading", true);
      if (isResetPaging) this.resetPaging();
      var _this = this;
      document.body.style.cursor = "wait";
      _this.datatable_loading = true;

      //Handling no values for active field
      if (_this.searchCriterias.active == "null") {
        _this.searchCriterias.active = null;
      }
      request("/v1/stock/mvt_stocks", "post", _this.searchCriterias, true, "api").then(function (response) {
        // we dynamically set the size of the array so the reactive side can still be engaged
        _this.baseModel.mvt_stocks.splice(_this.searchCriterias.paging.limits);
        _this.datatable_items = [];
        response.data.mvt_stocks.forEach(function (mvt) {
          var _mvt$stock_details$wa, _mvt$order, _mvt$creditNote;
          var mvtAdd = _objectSpread({}, mvt);
          mvtAdd.date = new Date(mvt.date).toLocaleString("en-US", {
            dateStyle: "short",
            timeStyle: "short"
          });
          mvtAdd.wine = "".concat(mvt.wine.producer.name, " : ").concat(mvt.wine.appellation.appellation, " ").concat(mvt.wine.year || "", " - ".concat(mvt.wine.bottling, " ml"));
          mvtAdd.qty = "".concat(mvt.quantity, " bottle").concat(mvt.quantity > 1 ? "s" : "");
          mvtAdd.stock_qty_after = mvt.stock_quantity_after !== null && mvt.mvt_type !== "deleted" ? "".concat(mvt.stock_quantity_after, " bottle").concat(mvt.stock_quantity_after > 1 ? "s" : "") : "";
          mvtAdd.warehouse = (_mvt$stock_details$wa = mvt.stock_details.warehouse.name) !== null && _mvt$stock_details$wa !== void 0 ? _mvt$stock_details$wa : "Direct Producer";
          mvtAdd.reference = "";
          if ((_mvt$order = mvt.order) !== null && _mvt$order !== void 0 && _mvt$order.referenceOrder) {
            var _mvt$order$invoiceNum;
            var orderDetailsHref = _this.orderDetails(+mvt.order.id);
            mvtAdd.reference += "<a href=\"".concat(orderDetailsHref, "\" target=\"_blank\" class=\"router-link\">").concat(mvt.order.referenceOrder.shorterReference(), "</a>");
            if (((_mvt$order$invoiceNum = mvt.order.invoiceNumberLabel) === null || _mvt$order$invoiceNum === void 0 ? void 0 : _mvt$order$invoiceNum.length) > 0) {
              mvtAdd.reference += "<br />".concat(mvt.order.invoiceNumberLabel.shorterReference());
            } else if (mvt.order.isPreventInvoice && mvt.order.dateOrder) {
              var order = {
                id_order: mvt.order.id,
                date_order: mvt.order.dateOrder
              };
              mvtAdd.reference += "<br />".concat(getOrderConfirmationReference(order));
            }
            if (mvt.id_purchase_order_label) mvtAdd.reference += "<br />".concat(mvt.id_purchase_order_label.shorterReference());else mvtAdd.reference += "<br />".concat(mvt.customerFullName);
          } else if (mvt.id_purchase_order_label) {
            var poDetailsHref = _this.poDetails(+mvt.id_purchase_order);
            mvtAdd.reference += "<a href=\"".concat(poDetailsHref, "\" target=\"_blank\" class=\"router-link\">").concat(mvt.id_purchase_order_label.shorterReference(), "</a>");
          } else if (((_mvt$creditNote = mvt.creditNote) === null || _mvt$creditNote === void 0 ? void 0 : _mvt$creditNote.id) > 0) {
            var href = _this.cnDetails(mvt.creditNote.id);
            mvtAdd.reference += "<a href=\"".concat(href, "\" target=\"_blank\" class=\"router-link\">").concat(mvt.creditNote.adminNumberLabel, "</a>");
          }
          if (!mvtAdd.reference) {
            var _mvtAdd$mvt_reasons;
            if (mvt.mvt_type === "acquisition" || mvt.mvt_type === "acquisition") {
              mvtAdd.reference = "Acquired without purchase order";
            } else if (mvt.mvt_type === "manual_adjustement") {
              mvtAdd.reference = "Manual correction";
            }
            if (((_mvtAdd$mvt_reasons = mvtAdd.mvt_reasons) === null || _mvtAdd$mvt_reasons === void 0 ? void 0 : _mvtAdd$mvt_reasons.length) > 0) {
              mvtAdd.reference += '<i class="pl-2 fas fa-edit"></i>';
            }
          }
          mvtAdd.destination = _this.getDestination(mvt);
          mvtAdd.user_initiator.fullname = mvtAdd.user_initiator.name + " " + mvtAdd.user_initiator.nickname;
          _this.datatable_items.push(mvtAdd);
        });

        //Finished loading
        _this.datatable_loading = false;
        _this.baseModel = {
          mvt_stocks: response.data.mvt_stocks,
          numberOfMvtStocks: response.data.total_number,
          numberOfPages: Math.ceil(response.data.total_number / _this.searchCriterias.paging.limits)
        };
        _this.searchCriterias.paging.currentPage = _this.searchCriterias.paging.askedPage + 1;
        if (!_this.searchCriterias.paging.currentPage) {
          _this.searchCriterias.paging.currentPage = 0;
        }
        document.body.style.cursor = "default";
        _this.$EventBus.$emit("loading", false);
      }).catch(function (e) {
        _this.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
        document.body.style.cursor = "default";
        _this.datatable_loading = false;
        _this.$EventBus.$emit("loading", false);
      });
    },
    detailsMovement: function detailsMovement(item) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (item.mvt_reasons) {
                _this4.$refs.mvtStockDetailsPopin.open(item);
              }
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    isRowClickableClass: function isRowClickableClass(item) {
      return !!item.mvt_reasons ? "cursor--pointer" : "";
    },
    orderDetails: function orderDetails(orderId) {
      var routeData = this.$router.resolve({
        name: "adminOrderSummary",
        params: {
          id: orderId
        }
      });
      return routeData.href;
    },
    poDetails: function poDetails(poId) {
      var routeData = this.$router.resolve({
        name: "adminEditPurchaseOrder",
        params: {
          id: poId
        }
      });
      return routeData.href;
    },
    cnDetails: function cnDetails(id) {
      var routeData = this.$router.resolve({
        name: "adminEditCreditNote",
        params: {
          id: id
        }
      });
      return routeData.href;
    }
  }
};